import script from "./LoginResetPasswordView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginResetPasswordView.vue?vue&type=script&setup=true&lang=ts"

import "./LoginResetPasswordView.vue?vue&type=style&index=0&id=456192c2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-456192c2"]])

export default __exports__